import { useEffect, useState, useRef } from 'react';

type ScrollDirection = 'up' | 'down' | 'none';

export const useScrollDirection = (thresholdValue = 0, lowRange = 0, highRange = 0) => {
    const [scrollDir, setScrollDir] = useState<ScrollDirection>('none');
    const [onPageTop, setOnPageTop] = useState(true);

    const ticking = useRef(false);
    const lastScrollY = useRef(0);

    useEffect(() => {
        const updateScrollDir = () => {
            const scrollY = window.scrollY;
            if (Math.abs(scrollY - lastScrollY.current) < thresholdValue) {
                ticking.current = false;
                return;
            }
            if (scrollY > lastScrollY.current && scrollDir !== 'down') {
                setScrollDir('down');
            } else if (scrollY < lastScrollY.current && scrollDir !== 'up') {
                setScrollDir('up');
            }

            lastScrollY.current = scrollY > 0 ? scrollY : 0;
            ticking.current = false;

            setOnPageTop(scrollY < highRange && scrollY > lowRange);
        };

        const onScroll = () => {
            if (!ticking.current) {
                ticking.current = true;
                requestAnimationFrame(updateScrollDir);
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollDir, thresholdValue, highRange, lowRange]);

    return { scrollDir, onPageTop };
};